import { render, staticRenderFns } from "./TheTicket.vue?vue&type=template&id=1e230c6b"
import script from "./TheTicket.vue?vue&type=script&lang=ts"
export * from "./TheTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e230c6b')) {
      api.createRecord('1e230c6b', component.options)
    } else {
      api.reload('1e230c6b', component.options)
    }
    module.hot.accept("./TheTicket.vue?vue&type=template&id=1e230c6b", function () {
      api.rerender('1e230c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/TheTicket.vue"
export default component.exports